module.exports = __webpack_public_path__ + "img/sn_kitchen_b1.3ab1729f.jpg";